module.exports = __webpack_public_path__ + "images/home/fioleWebdesigner.51df8cd2.svg";